import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import HistoryListComponent from './HistoryList/HistoryList.container.js';
import { I18nContext } from 'utils/I18n/context';

const HistoryPostbackPage = ({ location }) => {
    const { t } = useContext(I18nContext);
    const staticNames = t?.postbackPage?.history || { title: 'Postback History' };

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className="wrapper-content tools">
                <div className="ibox history-postback">
                    <HistoryListComponent
                        location={location}
                    />
                </div>
            </section>
        </React.Fragment>
    );
};

HistoryPostbackPage.propTypes = {
    location: PropTypes.object
};

HistoryPostbackPage.defaultProps = {
    location: {}
};

export default HistoryPostbackPage;
